import { render, staticRenderFns } from "./basicInfo.vue?vue&type=template&id=59c8ec77&scoped=true"
import script from "./basicInfo.vue?vue&type=script&lang=js"
export * from "./basicInfo.vue?vue&type=script&lang=js"
import style0 from "./basicInfo.vue?vue&type=style&index=0&id=59c8ec77&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c8ec77",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59c8ec77')) {
      api.createRecord('59c8ec77', component.options)
    } else {
      api.reload('59c8ec77', component.options)
    }
    module.hot.accept("./basicInfo.vue?vue&type=template&id=59c8ec77&scoped=true", function () {
      api.rerender('59c8ec77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/releaseManage/infoFrom/basicInfo.vue"
export default component.exports